import React, { Component } from "react";
import { getBoundingClientRect } from "../../utils/functions";
import { checkTranslation } from "../../utils/useful";
import FixedView from "../FixedView";
import TimeInput from "./TimeInput";

let moment = require('moment-timezone');

class DateTimeInput extends Component {

    state = {
        isOpen: false,
        startOfMonth: '',
        endOfMonth: '',
        week: ['mon', 'tu', 'we', 'th', 'fr', 'sa', 'su',],
        days: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,],
        month: { startDay: 0, daysCount: 30 },
        monthFromNow: 0,
        today: '',
        time: '00:00:00',
        translatedTime: { h: '00', m: '00' },
        timeDisabled: true,
        timeView: true
    }

    conditionalSettings(param, condition) {
        if (this.props.settings) {
            if (this.props.settings[param] == condition) {
                return true
            }
        }
        return false
    }

    componentWillMount() {
        this.setState({ title: this.props.data, today: new Date().getTime() })
        if (this.props.data) {
            this.setMonth(0, this.props.data)
            this.setState({ timeDisabled: false })
            let time = this.props.data
            let hour = moment(time).format('HH')
            let minute = moment(time).format('mm')
            let second = moment(time).format('ss')
            this.setState({ time: `${hour}:${minute}:${second}` })
        } else {
            this.setMonth(0)
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.data != this.props.data) {
            this.setMonth(0, this.props.data)
            this.setState({ title: this.props.data }, () => {
            })
        }
    }

    changeMonth(number) {
        this.setMonth(this.state.monthFromNow + number)
        this.setState({ monthFromNow: this.state.monthFromNow + number })
    }

    setMonth(fromNow, startDate) {
        let now = new Date();
        let days = []
        let start = moment(now).add(fromNow, 'month').startOf('month')
        if (startDate) {
            start = moment(startDate).add(fromNow, 'month').startOf('month')
        }
        for (let i = 0; i < moment(now).add(fromNow, 'month').daysInMonth(); i++) {
            days.push({ start: moment(start).add(i, 'day').startOf('day').valueOf(), end: moment(start).add(i, 'day').endOf('day').valueOf() })
        }
        this.setState({ month: { title: moment(start).format('YYYY-MMMM'), startDay: start.day(), days: days } })
    }

    setDay(day) {
        let startOrEnd = this.props.startOrEnd ? this.props.startOrEnd : "start"
        if (!this.props.startOrEnd && this.props.header.information?.startOrEnd) {
            startOrEnd = this.props.header.information.startOrEnd
        }
        let formatted = 0
        if (this.state.title) {
            let time = this.state.title
            let hour = moment(time).format('HH')
            let minute = moment(time).format('mm')
            let timeByMin = (Number(hour) * 60) + Number(minute)
            formatted = moment(day[startOrEnd]).add(timeByMin, 'minutes').valueOf()
        } else {
            formatted = day[startOrEnd]
        }
        this.props.changeValue(this.props.header.key, formatted, this.props.extra)
        this.setState({ title: formatted })
    }

    showDays() {
        let week = []
        let weeks = []
        let days = []
        let startDay = this.state.month.startDay
        let count = 0
        startDay = startDay === 0 ? 7 : startDay
        for (let i = 0; i < startDay - 1; i++) {
            days.push(null)
        }
        days = [...days, ...this.state.month.days]
        for (let i = 0; i < days.length; i++) {
            count++
            week.push(days[i])
            if (count == 7 || i == days.length - 1) {
                weeks.push(week)
                count = 0
                week = []
            }
        }
        let lastWeekLenght = weeks[weeks.length - 1].length
        if (lastWeekLenght < 7) {
            for (let i = 0; i < 7 - lastWeekLenght; i++) {
                weeks[weeks.length - 1].push(null)
            }
        }
        count = 0
        return weeks.map((week, index) => {
            return (
                <div key={index} className="d-flex text-center pld-2 prd-2 w-100 " style={{ justifyContent: 'space-between' }}>
                    {week.map((day, index1) => {
                        if (day == null) {
                            return (
                                <div key={index1} style={{ width: '100%', padding: 10, width: 35 }}>
                                </div>
                            )
                        } else {
                            count++
                            let isToday = (this.state.today >= day.start && this.state.today <= day.end) ? true : false
                            let selectedDay = (this.state.title >= day.start && this.state.title <= day.end) ? true : false
                            let available = true
                            if (this.props.endDate && day.start > this.props.endDate) {
                                available = false
                            }
                            if (this.props.startDate && day.end < this.props.startDate) {
                                available = false
                            }
                            return (
                                <div onClick={() => { if (available) this.setDay(day); this.setState({ timeDisabled: false, timeView: false }, () => { this.setState({ timeView: true }) }) }} key={index1} style={{ cursor: 'pointer', width: '100%', backgroundColor: selectedDay ? '#34C759' : '', padding: 0, borderRadius: 40, width: 35, height: 35, justifyContent: 'center', alignItems: 'center', display: 'flex' }}>
                                    <div style={{ backgroundColor: (selectedDay && isToday) ? '#34C759' : (isToday ? '#f5f5f5' : 'transparent'), borderRadius: 40, padding: 0, minWidth: 25, height: 25, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                        <span style={{ color: available ? (selectedDay ? '#fff' : '#345') : '#abc', fontSize: 12 }}>{count}</span>
                                    </div>
                                </div>
                            )
                        }
                    })}
                </div>
            )
        })
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.closeBox);
        window.removeEventListener('scroll', this.getPosition);
    }

    toggleOpen(open) {
        if (!this.props.header.information.disable) {
            let openState = open != null ? open : !this.state.isOpen
            this.fixedView.showView()
            this.setState({ isOpen: true })
        }
    }

    setWrapperRef(node) {
        this.wrapperRef = node;
    }

    getPosition = () => {
        let rect = getBoundingClientRect(this.wrapperRef)
        this.setState({ top: rect.top + 35, left: rect.left })
    }

    setTime = (key, value) => {
        let time = this.state.time
        let translatedTime = this.state.translatedTime
        // if (type == 'hour') {
        //     time[0] = value != '' ? Number(value) : '00'
        //     if (Number(value) != '00') {
        //         translatedTime.h = String(value)
        //     }
        //     else {
        //         translatedTime.h = '00'
        //     }
        // }
        // else if (type == 'min') {
        //     time[1] = value != '' ? Number(value) : '00'
        //     if (Number(value) != '00') {
        //         translatedTime.m = String(value)
        //     }
        //     else {
        //         translatedTime.m = '00'
        //     }
        // }
        time = value.split(":")
        let timeByMin = (Number(time[0]) * 3600) + Number(time[1] * 60) + Number(time[2])
        let formatted = moment(this.state.title).startOf('day').add(timeByMin, 'seconds').valueOf()
        this.props.changeValue(this.props.header.key, formatted, this.props.extra)
        this.setState({ time: value, translatedTime }, () => {
        })
    }

    lastStage = (cb) => { }

    dateClear = () => {
        this.setState({ time: '00:00:00', title: null, timeDisabled: true })
        if (this.props.changeValue) {
            this.props.changeValue(this.props.header.key, null, this.props.extra)
        }
    }

    render() {
        let info = this.props.header.information
        let disabled = this.props.header.information.disabled
        // console.log('this.props.header.information',this.props.header.information)
        return (
            <div className='mt-0 w-100 h-100' >
                <div className='position-relative' ref={ref => this.setWrapperRef(ref)}>
                    <div ref={el => this.currentNode = el} onClick={() => { if (!disabled) this.toggleOpen() }} disabled={disabled} onChange={e => { if (!disabled) { this.props.changeValue(this.props.header.key, e.target.value) } }} className='' defaultValue={this.props.data} placeholder={info?.placeHolder} style={{ height: 30, color: '#222', display: 'flex', alignItems: 'center', }} >
                        {/* <img className=' mrd-2' style={{ width: 36 }} src='/assets/icons/applets/inquiry/date-icon.svg' /> */}
                        <div className="flexc">
                            <div className="flexc cursor-pointer" style={{ width: '120px' }}>
                                {this.state.title && (
                                    <p className=" font-size-14 color-placholder weight-400 no-wrap date-text cursor-pointer">{(this.state.title ? moment(this.state.title).format('MMM DD, YYYY') : '') + ' '}</p>)
                                }
                                {!this.state.title && (
                                    <p className="w-100 font-size-14 weight-400 color-placholder cursor-pointer" style={{}}>{checkTranslation(info?.placeholder) + ' '}</p>)
                                }
                            </div>
                            {this.state.title && (
                                <div className="flexc cursor-pointer">
                                    <p className="font-size-14 color-placholder weight-400 cuesor-pointer">
                                        {/* {(this.state.title ? moment(this.state.title).format('HH') + ': ' : '00:') + (this.state.title ? moment(this.state.title).format('mm') + ' ' : '00')} */}
                                        {this.state.time ?? '00:00:00'}
                                    </p>
                                </div>
                            )}
                            {/* <div className="flexc cursor-pointer" onClick={() => { this.stageManager.changeStage('time') }}>
                                <p className="font-size-14 color-placholder weight-400 cuesor-pointer"> {(this.state.translatedTime.h != 0 ?
                                    this.state.translatedTime.h + ': ' : '00:') + (this.state.translatedTime.m != 0 ? this.state.translatedTime.m + ' ' : '00')}</p>
                            </div> */}
                        </div>
                    </div>
                    <FixedView ref={el => this.fixedView = el} nodeRef={this.currentNode} onHide={this.onHide} topOffset={8} bottomOffset={0} zIndex={10} xOffset={0} rightAlign={false} width={250}>
                        <div className="text-start" ref={el => this.listView = el} style={{ display: 'flex', zIndex: 5, width: '250px' }}>
                            <div className={'search-drop-down '} style={{ direction: 'ltr', paddingBottom: 10, paddingTop: 10, display: 'flex', flexDirection: 'column', width: '100%', backgroundColor: '#ffffff', borderRadius: 8, boxShadow: '0px 0px 30px rgba(0,0,0,0.1)', border: '1px solid #eee' }}>
                                <div className="d-flex flexc p-2" style={{ justifyContent: 'space-between' }}>
                                    <img className="rotate-180" onClick={() => this.changeMonth(-1)} src="/images/nexts.png" height="14px" />
                                    <p style={{ color: '#222' }}>{this.state.month.title}</p>
                                    <img className="" onClick={() => this.changeMonth(1)} src="/images/nexts.png" height="14px" />
                                    <div className="pr-1" style={{ fontSize: '0.8rem', cursor: 'pointer' }} onClick={() => this.dateClear()}>Clear</div>
                                </div>
                                <div className="d-flex p-2  text-center w-100" style={{ justifyContent: 'space-between' }}>
                                    {this.state.week.map((prop, index) => {
                                        return (
                                            <div className={'w-100'} style={{ width: 35, }}>
                                                <p style={{ color: '#789', fontSize: 12 }}>{prop}</p>
                                            </div>
                                        )
                                    })}
                                </div>
                                {this.showDays()}
                                <div className=" px-2 py-2 flexc " style={{ borderTop: '1px solid #c2c2c2' }}>
                                    <p className="mrd-2">Time</p>
                                    {this.state.timeView &&
                                        <div className="  p-2" style={{ background: '#cbcbcb42', width: 'fit-content', borderRadius: 8 }}>
                                            <TimeInput changeValue={this.setTime} header={{ key: 'time', information: { disabled: this.state.timeDisabled, seconds: false, } }} data={this.state.time} />
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </FixedView>
                </div>
            </div>
        );
    }
}

export default DateTimeInput;